<template>
	<div
		class="asmnt-catcards position-relative pointer"
		@click="$emit('select', category)"
	>
		<div class="fam-lato fw-M fs-14 text-blue double-line-truncate w-75">
			{{ category.categoryTitle }}
		</div>

		<div class="asmnt-catimgpos position-absolute">
			<img :src="categoryIcon" class="w-100 h-100" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: "AssessmentCategoryCard",
	props: {
		category: {
			type: Object,
			required: true,
		},
	},
	computed: {
		categoryIcon() {
			const iconMap = {
				"Data Science": "datascience.svg",
				"Web Development": "webdev.svg",
				"Mobile Development": "mobiledev.svg",
				"Software Development": "softwaredev.svg",
				"Software Engineering": "softwareeng.svg",
				"Software Testing": "softwaretest.svg",
				"Programming Language": "prgmnglang.svg",
				"Database Design and Development": "ddd.svg",
				"Other Assessment": "otherasmnt.svg",
			};

			const fileName =
				iconMap[this.category.categoryTitle] || "datascience.svg";

			return require(`@/assets/assessment/categories/${fileName}`);
		},
	},
};
</script>

<style scoped>
.asmnt-catcards {
	width: 100%;
	min-height: 75px;
	height: auto;
	background: #f2f6f9;
	border: 1px solid rgba(226, 232, 240, 0.5);
	border-radius: 8px;
	padding: 8px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.asmnt-catcards:hover {
	background: linear-gradient(98deg, #e8f0f8 0%, #ffffff 100%);
}

.asmnt-catimgpos {
	bottom: 0;
	right: 0;
}
@media (max-width: 1028px) {
	.asmnt-catimgpos {
		height: 45px;
		width: 45px;
	}
}
</style>
